import { Paperclip } from "lucide-react";
import { MessageActions } from "@/components/ChatExtras";
import { FileToRecordButton } from "@/components/FileToRecordDialog";
import { QuickReactions, ReactionChips } from "@/components/chat/Reactions";

export function MessageBubble({ m, mine, isAdmin, customerId, userId, showSender, onChanged }) {
  if (m.system && showSender) return <div className="text-center text-[11px] text-slate-500 italic py-1" data-testid={`message-system-${m.id}`}>{m.body} · {new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>;
  return (
    <div className={`flex items-center group ${mine ? "justify-end" : "justify-start"}`}>
      {mine && <MessageActions m={m} mine onChanged={onChanged} />}
      {mine && <QuickReactions m={m} mine onChanged={onChanged} />}
      <div className="max-w-[75%]">
        <div className={`rounded-lg px-3 py-2 text-sm shadow-sm ${mine ? "bg-blue-700 text-white" : "bg-white border border-slate-200 text-slate-900"}`} data-testid={`message-${m.id}`}>
          {!mine && <div className="text-[10px] font-semibold text-blue-700 mb-0.5" data-testid={`message-sender-${m.id}`}>{m.sender_name}{m.sender_company && !showSender ? <span className="font-normal text-slate-500"> · {m.sender_company}</span> : null}</div>}
          {mine && m.sender_name && m.sender_shared && <div className="text-[10px] font-semibold text-blue-100 mb-0.5" data-testid={`message-sender-${m.id}`}>{m.sender_name}</div>}
          <div>{m.body}</div>
          {m.attachments?.length > 0 && (
            <div className="mt-1.5 space-y-1">
              {m.attachments.map((a) => (
                <div key={a.id} className={`flex items-center gap-2 flex-wrap text-xs ${mine ? "text-blue-100" : "text-blue-700"}`}>
                  <a href={`${process.env.REACT_APP_BACKEND_URL}/api/messages/attachments/${a.id}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 underline" data-testid={`message-attachment-${a.id}`}>
                    <Paperclip className="h-3 w-3" />{a.file_name}<span className="opacity-70">({Math.max(1, Math.round((a.size || 0) / 1024))} KB)</span>
                  </a>
                  {isAdmin && <FileToRecordButton attachment={a} customerId={customerId} />}
                </div>
              ))}
            </div>
          )}
          <div className={`text-[10px] mt-1 ${mine ? "text-blue-100" : "text-slate-400"} font-mono`}>{new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}{mine && m.read_at ? " · read" : ""}</div>
        </div>
        <ReactionChips m={m} mine={mine} userId={userId} onChanged={onChanged} />
      </div>
      {!mine && <QuickReactions m={m} mine={false} onChanged={onChanged} />}
      {!mine && <MessageActions m={m} mine={false} onChanged={onChanged} />}
    </div>
  );
}
